import React from 'react'

import { useSatuEventTracker } from 'utils/satuEvent'
import { useAuth } from 'utils/auth'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { usePSStatus } from './useSummary'

const SATU_EVENT_NAME: string = 'pengkin_ps_interaction_v1'
const DEFAULT_TIMEOUT: number = 5_000 // 5 seconds

const convertToKeyValuePairs = (
  obj: Record<string, any>
): { key: string; value: any }[] => {
  return Object.entries(obj).map(([key, value]) => ({
    key,
    value,
  }))
}

export const usePPSTrackEvent = (providedSkpPsId: string = '') => {
  const { session } = useAuth()
  const { SETrackEvent } = useSatuEventTracker()
  const { period } = usePeriodContext()

  const { summary: psSummary, summaryFetchStatus: psSummaryFetchStatus } =
    usePSStatus({
      disabled: Boolean(providedSkpPsId),
    })

  const skpPsId: string = React.useMemo((): string => {
    if (psSummaryFetchStatus === 'success' && Boolean(psSummary?.skpPsId)) {
      return psSummary.skpPsId
    }
    return null
  }, [psSummary?.skpPsId, psSummaryFetchStatus])

  const trackEventBase = (
    eventCategory: string,
    eventAction: string,
    additionalParams: Record<string, any> = {}
  ): void => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        attributes: convertToKeyValuePairs({
          eventCategory,
          eventAction,
        }),
        custom_dimension: convertToKeyValuePairs({
          ...(!additionalParams?.email_ks && {
            email: session?.user?.email ?? null,
          }),
          periode_id: period.id,
          ...additionalParams,
        }),
      },
      timeout: DEFAULT_TIMEOUT,
      keepAlive: true,
      sendAttributes: false,
    })
  }

  const trackEvent = (
    eventCategory: string,
    eventAction: string,
    additionalParams?: Record<string, any>
  ): void => {
    trackEventBase(eventCategory, eventAction, {
      ...additionalParams,
      skp_id: providedSkpPsId || skpPsId,
    })
  }

  return {
    trackEventBase,
    trackEvent,
  }
}
